/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：705
 */

module.exports = {
  layout: "ResizableLayout_layout__jfiKe",
  resizable: "ResizableLayout_resizable__3FYyj",
  resizing: "ResizableLayout_resizing__uD63n",
  resizer: "ResizableLayout_resizer__XkgTN",
  top: "ResizableLayout_top__3jjG0",
  bottom: "ResizableLayout_bottom__3hpHH",
  left: "ResizableLayout_left__1_oRG",
  right: "ResizableLayout_right__SyQMU",
  row: "ResizableLayout_row__2ab31",
  col: "ResizableLayout_col__2i2MU"
}
